import { render, staticRenderFns } from "./free-credit.vue?vue&type=template&id=0c27be8a&scoped=true&"
import script from "./free-credit.vue?vue&type=script&lang=js&"
export * from "./free-credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27be8a",
  null
  
)

export default component.exports